<template>
    <div>
        <v-dialog v-model="showDialog" width="50vw" eager @click:outside="closeModal">
            <v-card>
                <v-toolbar color="secondary" flat class="white--text">
                    <v-toolbar-title class="font-weight-bold">{{
                        $t("deforestation.viewGeolocation") || "Primary Geofence"
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon class="white--text" @click="closeModal">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container fluid>
                    <v-row class="d-flex mb-5">
                        <v-col cols="12">
                            <div class="google-map" style="width:100%;height:78vh; z-index: 0;" id="map" ref="googleMap"></div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { getGoogleMapsLoader } from '@/mixins/GoogleMapLoaderSingleton';

export default {
    props: {
        // Updated props to match Information.vue
        dialog: {
            type: Boolean,
            required: true
        },
        farmDetails: {
            type: Object,
        },
        coordinates: {
            type: Array
        },
        disableEditGeofence: {
            type: Boolean,
            default: true
        },
        diligenceReportId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            farmGeofenceType: "polygon",
            farmGeofenceRadius: 0.0,
            parentPolygonCoords: [],
            loader: null,
            latitude: 0,
            longitude: 0,
            google: null,
            map: null,
            marker: null,
            polygon: null,
            circle: null,
            mapOptions: {
                mapTypeId: 'satellite',
                center: {
                    lat: 0,
                    lng: 0
                },
                zoom: 18,
                disableDefaultUI: true,
                zoomControl: true,
            }
        }
    },
    computed: {
        // Safely handle the dialog v-model without mutating the prop directly
        showDialog: {
            get() {
                return this.dialog;
            },
            set(value) {
                if (!value) {
                    this.closeModal();
                }
            }
        }
    },
    watch: {
        // Watch for dialog to open, THEN load the map to prevent DOM errors
        dialog: {
            immediate: true,
            async handler(isShowing) {
                if (isShowing) {
                    await this.$nextTick(); // Wait for the <v-dialog> to render the map div
                    this.setupMapData();    // Parse the new props
                    
                    try {
                        const loader = getGoogleMapsLoader();
                        const google = await loader.load();
                        await this.initializeMap(google);
                        this.loader = loader;
                    } catch (e) {
                        console.error('Map Loader Error:', e);
                    }
                }
            }
        }
    },
    methods: {
      sortCoordinates(coords) {
    if (!coords || coords.length <= 2) return coords;

    // 1. Calculate the center point (centroid) of the polygon
    const center = coords.reduce((acc, coord) => {
        acc.lat += coord.lat;
        acc.lng += coord.lng;
        return acc;
    }, { lat: 0, lng: 0 });

    center.lat /= coords.length;
    center.lng /= coords.length;

    // 2. Sort the coordinates clockwise based on their angle from the center
    return coords.sort((a, b) => {
        const angleA = Math.atan2(a.lng - center.lng, a.lat - center.lat);
        const angleB = Math.atan2(b.lng - center.lng, b.lat - center.lat);
        return angleA - angleB;
    });
},
        closeModal() {
            // Emits exactly what Information.vue is listening for
            this.$emit('closeViewGeoLocationModal');
        },
        
        setupMapData() {
            // Extract the farm object from the wrapper
            const farm = this.farmDetails?.farm;

            // Initialize coordinates and type based on props
            if (farm) {
                if (farm?.segments && farm?.segments[0]?.geofenceRadius) {
                    this.farmGeofenceType = "circular";
                    this.farmGeofenceRadius = farm.segments[0].geofenceRadius;
                }

                let codes = [];
                console.log('Farm Coordinates:', JSON.stringify(farm.FarmCoordinates));
                console.log('Farm coordinates:', JSON.stringify(farm.coordinates));
                if (farm.FarmCoordinates && farm.FarmCoordinates.length > 0) {
                    codes = farm.FarmCoordinates.map(elm => ({ lat: parseFloat(elm['lat']), lng: parseFloat(elm['log']) }));
                } else if (farm.coordinates && farm.coordinates.length > 0) {
                    codes = farm.coordinates.map(elm => ({ lat: parseFloat(elm['lat']), lng: parseFloat(elm['log']) }));
                }
                this.parentPolygonCoords = codes;
                console.log('Parsed Coordinates:', JSON.stringify(this.parentPolygonCoords));

                if (farm.lat && farm.log) {
                    this.latitude = parseFloat(farm.lat);
                    this.longitude = parseFloat(farm.log);
                }
            }

            // Override with coordinates prop if Information.vue passed it
            if (this.coordinates && this.coordinates.length > 0) {
                // Check if it's the circular fallback format passed from Information.vue
                if (this.coordinates[0].radius) {
                    this.farmGeofenceType = "circular";
                    this.farmGeofenceRadius = parseFloat(this.coordinates[0].radius);
                    this.latitude = parseFloat(this.coordinates[0].lat);
                    this.longitude = parseFloat(this.coordinates[0].log);
                } else {
                    // this.parentPolygonCoords = this.coordinates.map(elm => ({ 
                    //     lat: parseFloat(elm.lat), 
                    //     lng: parseFloat(elm.log) 
                    // }));
                }
            }

            // Establish map center point
            if (this.latitude && this.longitude) {
                this.mapOptions.center.lat = this.parentPolygonCoords.length > 0 ? this.parentPolygonCoords[0].lat : this.latitude;
                this.mapOptions.center.lng = this.parentPolygonCoords.length > 0 ? this.parentPolygonCoords[0].lng : this.longitude;
            } else if (this.parentPolygonCoords.length > 0) {
                this.mapOptions.center.lat = this.parentPolygonCoords[0].lat;
                this.mapOptions.center.lng = this.parentPolygonCoords[0].lng;
            }

        },

        async initializeMap(google) {
            this.google = google;
            const mapContainer = this.$refs.googleMap;
            
            if (!mapContainer) return; // Safety check

            this.map = await new google.maps.Map(mapContainer, this.mapOptions);

            this.createMarker();

            if (this.farmGeofenceType === 'circular' && this.farmGeofenceRadius > 0) {
                this.createCircle(this.farmGeofenceRadius);
            } else if (this.parentPolygonCoords.length > 0) {
                this.createPolygon();
            }
        },

        createMarker() {
            if (this.marker != null) this.marker.setMap(null);
            
            if (this.latitude && this.longitude) {
                const latLng = { lat: this.latitude, lng: this.longitude };
                this.marker = new this.google.maps.Marker({
                    position: latLng,
                    map: this.map
                });
            }
        },

        async createPolygon() {
            if (this.polygon != null) this.polygon.setMap(null);

            this.polygon = await new this.google.maps.Polygon({
                paths: this.parentPolygonCoords,
                strokeColor: "#1F5D51",
                strokeOpacity: 0.8,
                strokeWeight: 3,
                fillColor: "#E5F8F1",
                fillOpacity: 0.7,
                editable: false,
                draggable: false,
            });
            
            this.polygon.setMap(this.map);
        },

        async createCircle(radius = 0) {
            if (this.circle !== null) {
                this.circle.setMap(null);
            }

            this.circle = await new this.google.maps.Circle({
                fillColor: '#FFFFFF',
                fillOpacity: 0.2,
                strokeWeight: 0,
                map: this.map,
                center: {
                    lat: this.latitude,
                    lng: this.longitude
                },
                radius: radius,
                editable: false,
                draggable: false
            });
            this.circle.setMap(this.map);
        }
    }
}
</script>

<style scoped>
.google-map {
    border-radius: 4px;
    overflow: hidden;
}
</style>